export default __webpack_public_path__ + "static/media/DSC_7433.b04c5c73.jpg";